/**
 *
 * EventRedirect
 *
 */

import { mapState, mapGetters, mapActions } from 'vuex';

import Spinner from '@/components/Spinner.vue';

import { LOADING_MESSAGE } from './PlvLiveRedirect.constants';

export default {
  name: 'PlvLiveRedirect',

  components: {
    Spinner,
  },

  data() {
    return {
      loadingMessage: LOADING_MESSAGE,

      redirect_uri: '',
    };
  },

  computed: {
    ...mapState('PlvLiveRedirect', {
      ms_plvWatchLink: 'plvWatchLink',
    }),

    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),
  },

  methods: {
    ...mapActions('PlvLiveRedirect', {
      ma_getPlvWatchLink: 'getPlvWatchLink',
    }),

    async getPlvWatchLink() {
      await this.ma_getPlvWatchLink({
        channelId: this.$route.params.channelId,
        invitePosterId: this.$route.query.invitePosterId,
      });
      if (this.ms_plvWatchLink && this.ms_plvWatchLink.watchUrl) {
        window.location.href = this.ms_plvWatchLink.watchUrl;
      }
    },
  },

  created() {
    this.getPlvWatchLink();
  },
};
